import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUpdateSystemSettingsMutation } from 'api/generated/graphql';
import { parseSystemSettingsEntity, useError } from 'api/helpers';

interface Params {
  isAutomaticPersonalAccountGenerationEnabled: boolean;
  sessionLengthInDays: number;
  passwordExpiresInDays: number | null;
}

export const useUpdateSystemSettings = () => {
  const [handle, { data, loading, error: apolloError }] =
    useUpdateSystemSettingsMutation();

  const error = useError(apolloError);

  return {
    settings: parseSystemSettingsEntity(data?.systemSettings),
    loading,
    error,
    updateSystemSettings: useCallback(
      async (params: Params) => {
        const res = await handle({
          variables: {
            input: {
              isAutomaticPersonalAccountGenerationEnabled:
                params.isAutomaticPersonalAccountGenerationEnabled,
              jwtRefreshTokenExpiresInDays: params.sessionLengthInDays,
              passwordExpiresInDays: params.passwordExpiresInDays,
            },
          },
        });
        return parseSystemSettingsEntity(res.data?.systemSettings);
      },
      [handle]
    ),
  };
};
